import { HolyQuranBaseDto } from '../../types/api.types';
import { BiblioDetailModel, HoldingItem } from '../../types/types';

declare const require: any;

export class BiblioDetailMapper {

  static toModel(dto: HolyQuranBaseDto, items: any[]): BiblioDetailModel {
    return {
      id: dto.id,
      title: dto.description ?? '',
      titleAR: dto.nameAR ?? '',
      titleEN: dto.nameEN ?? '',
      subtitle: dto.mada ?? null,
      author: dto.authorName ?? null,
      abstract: dto.description ?? null,
      notes: dto.documentationRestrictions ?? null,
      isbn: dto.barcode ?? null,
      issn: null,
      itemType: dto.quranCalligraphy?.nameAR ?? 'UNKNOWN',
      itemTypeLabel: dto.quranCalligraphy?.nameAR ?? null,
      language: null,
      publisher: dto.createdPlace ?? null,
      publicationPlace: dto.createdPlace ?? null,
      publicationYear: dto.createdDate ?? null,
      pages: dto.pagesNumber?.toString() ?? null,
      callNumber: dto.savedNumber ?? null,
      coverImageUrl: BiblioDetailMapper.buildCoverImageUrl(dto),
      hijriDate: BiblioDetailMapper.formatHijriDate(dto.createdDate),
      serial: false,
      rawDto: dto,
      barcode: dto.barcode ?? null,
      savedNumber: dto.savedNumber ?? null,
      library: dto.library ?? null,
      calligrapherName: dto.calligrapherName ?? null,
      recordNumber: dto.recordNumber ?? null,
      codeNumber: dto.codeNumber ?? null,
      files: dto.files ?? [],
      holdings: [],
    };
  }

  private static buildCoverImageUrl(dto: HolyQuranBaseDto): string | null {
    if (dto.thumbnail?.filePath) {
      return dto.thumbnail.filePath;
    }
    return null;
  }

  private static formatHijriDate(gregorianDate: string | null | undefined): string | null {
    if (!gregorianDate) return null;
    try {
      const moment = require('moment-hijri');
      const m = moment(gregorianDate, 'YYYY-MM-DD');
      if (!m.isValid()) return null;
      return m.format('iD iMMMM iYYYYهـ');
    } catch {
      return gregorianDate;
    }
  }
}
